import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { BackButtonComponent } from "@shared/components/back-button/back-button.component";
import { environment } from "./../../../environments/environment";
import { ApiService } from "../../../services/api.service";
import { HealthprofilService } from "../../../services/healthprofil.service";
import { ScrollService } from "../../../services/scroll/scroll.service";

@Component({
	selector: "app-trainingvideo",
	templateUrl: "./trainingvideo.component.html",
	styleUrls: ["./trainingvideo.component.scss"],
	imports: [RouterLink, TranslatePipe, BackButtonComponent],
})
export class TrainingvideoComponent implements OnInit {
	private router = inject(Router);
	private activeRoute = inject(ActivatedRoute);
	private scrollService = inject(ScrollService);

	public healthprofilService: HealthprofilService;
	public apiservice: ApiService;
	public exerciseId: string = "";
	public TrainingExercise: any;
	public VideoPath: string = "";
	public ImagePath: string = "";
	public VideoUrl: string = "";
	public ImageUrl: string = "";

	constructor() {
		const healthProfilService = inject(HealthprofilService);
		const apiService = inject(ApiService);

		this.healthprofilService = healthProfilService;
		this.apiservice = apiService;
	}

	ngOnInit(): void {
		this.scrollService.scrollToTop("auto");

		this.activeRoute.paramMap.subscribe((params) => {
			this.exerciseId = params.get("exerciseId") || "";
		});

		this.apiservice.GetAvailableActivities().then((activities: any) => {
			const activity = activities.find((activity: any) => {
				return activity.Text === "ShowExercise";
			});

			if (activity !== undefined) {
				this.apiservice.CreateActivityLog(activity.Id, this.exerciseId);
			}
		}, 500);

		this.TrainingExercise = this.healthprofilService
			.getReportData()
			.TrainingExercises.find(
				(exercise: any) => exercise.Id === this.exerciseId,
			);

		this.VideoPath = environment.TrainingVideoPath;
		this.ImagePath = environment.TrainingImagePath;

		this.VideoUrl = this.VideoPath + this.TrainingExercise.Video;
		this.ImageUrl = this.ImagePath + this.TrainingExercise.Image;
	}

	backToTraining = () => {
		this.router.navigate(["/healthprofil/training"]);
	};
}
